import { ReactElement } from 'react';
import { useEffect, useState } from 'react';

interface ProgressBarProps {
  percent: number;
}

export const ProgressBar = ({ percent }: ProgressBarProps): ReactElement => {
  // Adds an initial transition to the progress bar on mount
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={'h-1 w-full overflow-hidden bg-primary-300'}>
      <div
        className={'h-1 bg-primary-color transition-[width] duration-300'}
        style={{ width: `${!mounted ? 0 : percent}%` }}
      />
    </div>
  );
};
